import type { IErrorApiResponse, ISuccessApiResponse } from '@wyz/types';
import {
  OverridableQuery,
  serialize,
  useQuery,
  UseQueryOptions,
} from '@wyz/utils';
import { ConnectQueryKeys } from '~/connect/api';
import { useApi } from '~/common/context';
import { IVatZone } from '~/connect/types';
import { PAGINATE_ALL_LIMIT } from '~/common/helpers';

type Options = {
  getAll?: OverridableQuery<
    UseQueryOptions<ISuccessApiResponse<IVatZone[]>, IErrorApiResponse> & {
      args?: {
        countryId?: number;
      };
    }
  >;
};

export const useManageVatZones = (options: Options) => {
  const { callCoreApi } = useApi();

  return useQuery<ISuccessApiResponse<Array<IVatZone>>>({
    queryKey: ConnectQueryKeys.vatZones.base(options.getAll?.args?.countryId),
    queryFn: () =>
      callCoreApi<ISuccessApiResponse<Array<IVatZone>>>(
        `/settings/api/countries/${
          options.getAll?.args?.countryId as number
        }/vat-zones?${serialize({ limit: PAGINATE_ALL_LIMIT })}`,
        {},
      ),
    gcTime: Infinity,
    staleTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    enabled: Boolean(options.getAll?.args?.countryId),
  });
};
